export const ClubsInfo = {
    "Clubs": {
        "Iron": [
            "1Iron",
            "2Iron",
            "3Iron",
            "4Iron",
            "5Iron",
            "6Iron",
            "7Iron",
            "8Iron",
            "9Iron"
        ],
        "Wood": [
            "2Wood",
            "3Wood",
            "4Wood",
            "5Wood",
            "6Wood",
            "7Wood",
            "8Wood",
            "9Wood"
        ],
        "Driver": [
            "Driver"
        ],
        "Wedge": [
            "PitchingWedge",
            "SandWedge",
            "LobWedge",
            "50Wedge",
            "52Wedge",
            "54Wedge",
            "56Wedge",
            "58Wedge",
            "60Wedge"
        ],
        "Hybrid": [
            "1Hybrid",
            "2Hybrid",
            "3Hybrid",
            "4Hybrid",
            "5Hybrid",
            "6Hybrid",
            "7Hybrid",
            "8Hybrid",
            "9Hybrid"
        ]
    }
}